import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import ContentBox from '../../../layout/component/ContentBox'
import Checkbox from '../../../form/component/Checkbox'
import {
    PARTNER_MGMT_CATEGORY_LIST,
    SCAN_UPLOAD_MODE_LIST,
    MANDATORY_FIELDS,
    CLINIC_REGION_LIST,
    CLINIC_PRIORITIZATION_LIST
} from './const'
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'
import getRegionList from './region-list'
import MessageBox from './MessageBox'
import { Redirect } from 'react-router-dom'

const InputLine = (props) => {
    const labelClass = checkMessageList(props.validation, props.name)

    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label} labelClassName={labelClass} />
            </Column>
            <Column size={4}>
                <Input
                    object={props.store}
                    onChange={props.onChange}
                    name={props.name}
                    readOnly={props.readOnly}
                />
            </Column>
        </Row>
    )
}

function filterInt(min, max) {
    return (value) => {

        const filteredValue = value.replace(',', '.').split('.')[0]
            .replace(/[\D]/,'');

        if (filteredValue === '') {
            return '';
        }

        return Math.min(Math.max(filteredValue, min), max);
    }
}

function filterDecimalDegreesNumber() {
    return (value) => {
        const filteredValue = value.replace(',', '.').replace(/[^0-9.-]/, '');

        if (filteredValue === '') {
            return null;
        }

        return filteredValue;
    }
}

const PositiveNumberInputLine = (props) => {
    const labelClass = checkMessageList(props.validation, props.name)

    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label} labelClassName={labelClass}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Input
                    object={props.store}
                    onChange={props.onChange}
                    name={props.name}
                    readOnly={props.readOnly}
                    filterValue={filterInt(0, props.max || Infinity)}
                />
            </Column>
        </Row>
    )
}

const FloatNumberInputLine = (props) => {
    const labelClass = checkMessageList(props.validation, props.name)

    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label} labelClassName={labelClass}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Input
                    object={props.store}
                    onChange={props.onChange}
                    name={props.name}
                    readOnly={props.readOnly}
                    filterValue={filterDecimalDegreesNumber()}
                />
            </Column>
        </Row>
    )
}

const SelectLine = (props) => {
    const labelClass = checkMessageList(props.validation, props.name)
    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label} labelClassName={labelClass}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Select
                    name={props.name}
                    object={props.store}
                    valueList={props.valueList}
                    onChange={props.onChange}
                    addEmpty={props.addEmpty}
                />
            </Column>
        </Row>
    )
}

const CheckboxLine = (props) => {
    const labelClass = checkMessageList(props.validation, props.name)

    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label} labelClassName={labelClass}>
                </LabelInput>
            </Column>
            <Column size={10}>
                <Checkbox
                    object={props.store}
                    name={props.name}
                    onChange={props.onChange}
                > Yes {props.note}
                </Checkbox>
            </Column>
        </Row>

    )
}

const checkMessageList = (messageList, item) => {
    if (Array.isArray(messageList) && messageList.find(el => el.messageId === item)) {
        return 'text-danger bg-danger'
    }
    return ''
}

const MAX_DAYS_IN_FUTURE = 365;

// eslint-disable-next-line react/prop-types
const StoreForm = ({title, store, saveStore, editStore, validationMessageList, pushValidationList, redirect, isFetching}) => {
    const onChange = (name, value) => {
        editStore(name, value)
    }

    const onChangeFrontendBookingName = (name, value) => {
        value = value.toLowerCase().replace(/ /g, '-')
        editStore(name, value)
    }

    const onChangeTechnicalName = (name, value) => {
        value = value.toLowerCase().replace(/ /g, '-')
        editStore(name, value)
    }

    const isReadOnly = () => {
        return !!store.id
    }

    const onSave = () => {
        const messageList = validate()
        if (messageList.length === 0) {
            saveStore()
        }
    }

    const validate = () => {
        const messageList = [];

        (MANDATORY_FIELDS).forEach(el => {
            // eslint-disable-next-line no-prototype-builtins
            if (!store.hasOwnProperty(el.id) || !store[el.id]) {
                messageList.push({
                    messageId: el.id,
                    message: `Field ${el.value} is mandatory, please fill before saving`,
                })
            }
        })
        pushValidationList(messageList)
        return messageList
    }

    if (redirect) {
        return <Redirect to='/store/search/' />
    }

    return (
        <ContentBox title={title}>

            <InputLine
                label='Clinic Name *'
                store={store}
                name='clinicName'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='City *'
                store={store}
                name='city'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Address *'
                store={store}
                name='streetAddress'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='ZIP *'
                store={store}
                name='zip'
                onChange={onChange}
                validation={validationMessageList}
            />

            <SelectLine
                label='Country *'
                name='countryCode'
                store={store}
                valueList={COUNTRY_CODE_LIST}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <SelectLine
                label='State'
                name='state'
                store={store}
                valueList={getRegionList(store.countryCode)}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <InputLine
                label='Address extension'
                store={store}
                name='addressExtension'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Address description'
                store={store}
                name='addressDescription'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='eMail Address *'
                store={store}
                name='email'
                onChange={onChange}
                validation={validationMessageList}
            />

            <h2 className={'text-primary'}>Clinic Characteristics</h2>

            <CheckboxLine
                label='Active'
                store={store}
                name='isActive'
                onChange={onChange}
                validation={validationMessageList}
            >
            </CheckboxLine>

            <CheckboxLine
                label='Partner clinic'
                store={store}
                name='isPartner'
                onChange={onChange}
                validation={validationMessageList}
            />

            <CheckboxLine
                label='Provides Pretreatment'
                store={store}
                name='isPretreatmentProvider'
                onChange={onChange}
                validation={validationMessageList}
            />

            <SelectLine
                label='Clinic Region'
                name='clinicRegion'
                store={store}
                valueList={CLINIC_REGION_LIST}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />


            <SelectLine
                label='Clinic Prioritization'
                name='clinicPrioritization'
                store={store}
                onChange={onChange}
                valueList={CLINIC_PRIORITIZATION_LIST}
                validation={validationMessageList}
                addEmpty={true}
            />

            <SelectLine
                label='Partner Mgmt. Cat. *'
                name='partnerMgmtCategory'
                store={store}
                valueList={PARTNER_MGMT_CATEGORY_LIST}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <CheckboxLine
                label='IPR available'
                store={store}
                name='iprProvider'
                onChange={onChange}
                validation={validationMessageList}
            />

            <CheckboxLine
                label='Attachment available'
                store={store}
                name='attachmentAvailable'
                onChange={onChange}
                validation={validationMessageList}
            />

            <CheckboxLine
                label='Allow IPR/3DScan timeslots in parallel'
                store={store}
                name='hasSpecialIprLogic'
                onChange={onChange}
                validation={validationMessageList}
            />

            <CheckboxLine
                label='Implant provider'
                store={store}
                name='isImplantProvider'
                onChange={onChange}
                validation={validationMessageList}
            />

            <SelectLine
                label='Upload Mechanism *'
                name='scanFileUploadMechanism'
                store={store}
                valueList={SCAN_UPLOAD_MODE_LIST}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <PositiveNumberInputLine
                label='3D-scan price'
                store={store}
                name='inShopScanPrice'
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <PositiveNumberInputLine
                label='IPR price'
                store={store}
                name='iprPrice'
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <h2 className={'text-primary'}>Other</h2>

            <InputLine
                label='Technical Name *'
                store={store}
                name='technicalName'
                onChange={onChangeTechnicalName}
                validation={validationMessageList}
                readOnly={isReadOnly()}
            />

            <InputLine
                label='Display Name *'
                store={store}
                name='displayName'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Frontend Booking Name *'
                store={store}
                name='frontendBookingName'
                onChange={onChangeFrontendBookingName}
                readOnly={isReadOnly()}
                validation={validationMessageList}
            />

            <InputLine
                label='Budget City Name *'
                store={store}
                name='budgetCityName'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Cost Center *'
                store={store}
                name='costCenter'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Google Maps URL *'
                store={store}
                name='googleMapsLink'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Google Place ID *'
                store={store}
                name='googlePlaceId'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='Google Feedback Link'
                store={store}
                name='googleFeedbackLink'
                onChange={onChange}
                validation={validationMessageList}
            />
            <FloatNumberInputLine
                label='Latitude *'
                store={store}
                name='latitude'
                onChange={onChange}
                validation={validationMessageList}
            />
            <FloatNumberInputLine
                label='Longitude *'
                store={store}
                name='longitude'
                onChange={onChange}
                validation={validationMessageList}
            />
            <PositiveNumberInputLine
                label='Booking days in advance 3d Scan *'
                store={store}
                name='bookingDaysInAdvance3dScan'
                onChange={onChange}
                validation={validationMessageList}
                max={MAX_DAYS_IN_FUTURE}
            />
            <PositiveNumberInputLine
                label='Booking days in advance IPR *'
                store={store}
                name='bookingDaysInAdvanceIpr'
                onChange={onChange}
                validation={validationMessageList}
                max={MAX_DAYS_IN_FUTURE}
            />

            <button
                className="btn btn-primary"
                onClick={onSave}
                disabled={isFetching}
            >
                Save
            </button>

            <Row>
                <Column size={12}>
                    <MessageBox
                        messageList={validationMessageList}
                    />
                </Column>
            </Row>

        </ContentBox>
    )
}

StoreForm.propTypes = {
    title: PropTypes.string.isRequired,
    store: PropTypes.object.isRequired,
    saveStore: PropTypes.func.isRequired,
    editStore: PropTypes.func.isRequired,
    pushValidationList: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array,
}

export default StoreForm



// WEBPACK FOOTER //
// ./src/modules/store/component/form/StoreForm.js